<template>
  <MerchantGroupForm :merchant-group-id="merchantGroupId" />
</template>

<script setup lang="ts">
const props = defineProps<{
  merchantGroupId: string
}>()
</script>
